<script setup>

import Select from "primevue/select";
import ToggleSwitch from "primevue/toggleswitch";
import { trans } from 'laravel-vue-i18n';
const form = defineModel();

const eventsSettings = [
    { value: 'all_events',              label: trans('settings.block_all_events') },
    { value: 'only_unavailable_events', label: trans('settings.block_unavailable_events') },
    { value: 'only_free_events',        label: trans('settings.block_free_events') },
]

const blockingSettings = [
    { value: 'only_accepted_reservations', label: trans('settings.block_only_accepted') },
    { value: 'all_reservations',           label: trans('settings.block_all_reservations') },
]
</script>

<template>
    <div class="setting-item mb-6">
        <label class="block text-sm font-medium mb-2">{{ $t('settings.cal_block_label') }}</label>
        <Select
            v-model="form.calendar_occupancy_settings"
            :options="eventsSettings"
            optionLabel="label"
            option-value="value"
            :placeholder="$t('settings.select_placeholder')"
            class="w-full"
        />
        <p class="text-sm text-gray-500 mt-2">{{ $t('settings.cal_block_desc') }}</p>
    </div>
    <div class="setting-item">
        <label class="block text-sm font-medium mb-2">{{ $t('settings.reservation_block_label') }}</label>
        <Select
            v-model="form.roori_occupancy_settings"
            :options="blockingSettings"
            optionLabel="label"
            option-value="value"
            :placeholder="$t('settings.select_placeholder')"
            class="w-full"
        />
        <p class="text-sm text-gray-500 mt-2">{{ $t('settings.reservation_block_desc') }}</p>
    </div>
    <div class="setting-item mt-6">
        <div class="flex gap-5 items-center">
            <ToggleSwitch v-model="form.show_partial_availability"></ToggleSwitch>
            <label class="text-sm font-medium">{{ $t('settings.show_partial_availability_label') }}</label>
        </div>
        <p class="text-sm text-gray-500 mt-2">{{ $t('settings.show_partial_availability_desc') }}</p>
    </div>
</template>

<style scoped lang="scss">

</style>
